import * as z from "zod/v4";

export const deleteOrderTrackingViewFolder = {
  name: "deleteOrderTrackingViewFolder" as const,
  input: z.object({ folderId: z.string() }),
  output: z.object({}),
};
